import { __decorate } from "tslib";
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import moment from 'moment';
import PageTitle from '@/components/v2/PageTitle.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import Paginator from '@/components/v2/Paginator.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import ActionButton from '@/components/action_button/Index.vue';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import PageRecipientOrders from '@/plugins/graphql/queries/v2/copilot_inbox_manager/page-recipient-orders.gql';
import PageRecipientOrderSubscription from '@/plugins/graphql/subscriptions/copilot_inbox_manager/page-recipient-order-details.gql';
import { OrderFullModel } from '@/helpers/entities/models/OrderFullModel';
import { textTruncate } from '@/helpers/text_truncate';
let AffiliateAutomationTable = class AffiliateAutomationTable extends Mixins(FormMixin, ViewportSizeMixin, PaginatorMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.resetPagination = false;
        this.tableHeaders = [
            {
                text: 'PRODUCT',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'QUANTITY',
                value: 'quantity',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PRICE',
                value: 'price',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DATE',
                value: 'createdAt',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PAYMENT',
                value: 'paymentName',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SHIPPING',
                value: 'shippingtMethod',
                align: 'center',
                sortable: false,
            },
        ];
        this.subscription = null;
    }
    //   private selectedAutomation: Nullable<string> = null;
    //   private firstCursor: Nullable<string> = null;
    humanReadableDate(date) {
        return moment(date).format('ddd MMM DD YYYY h:mm A');
    }
    resetPaginationChecker() {
        this.resetPagination = false;
    }
    truncatedText(text) {
        return textTruncate(text || '', 20);
    }
    initiateSubscription() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.subscription = this.$apollo
            .subscribe({
            query: PageRecipientOrderSubscription,
            variables: {
                prGlobalId: this.$store.state.selectedRecipient.baseUuid,
            },
        })
            .subscribe({
            next: ({ data }) => {
                const { order, orderCount } = data.copilotOrderDetails;
                this.addOrder(order, orderCount);
            },
            error(err) {
                console.error('Subscription error:', err);
            },
        });
    }
    addOrder(order, orderCount) {
        const vm = this;
        const newOrder = new OrderFullModel(order);
        this.resetPagination = true;
        vm.pageRecipientOrders.unshift(newOrder);
        if (vm.pageRecipientOrders.length > 5) {
            vm.pageRecipientOrders.pop();
        }
        this.totalCount = orderCount;
    }
    onPRChange(newVal, oldVal) {
        this.initiateSubscription();
    }
};
__decorate([
    Getter('selectedRecipient')
], AffiliateAutomationTable.prototype, "selectedRecipient", void 0);
__decorate([
    Prop({ type: String, default: '' })
], AffiliateAutomationTable.prototype, "pageRecipientUuid", void 0);
__decorate([
    Watch('startCursor')
], AffiliateAutomationTable.prototype, "onPRChange", null);
AffiliateAutomationTable = __decorate([
    Component({
        components: {
            PageTitle,
            BaseSubtitle,
            ActionButton,
            Paginator,
            ConfirmationDialog,
            BaseOverlayLoader,
        },
        apollo: {
            pageRecipientOrders: {
                query: PageRecipientOrders,
                variables() {
                    return {
                        pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                        after: this.startCursor,
                        first: 5,
                    };
                },
                update(data) {
                    const { pageInfo, totalCount, edges } = data.recipientOrders;
                    this.pageInfo = pageInfo;
                    this.totalCount = totalCount;
                    return edges.map((order) => new OrderFullModel(order.node));
                },
                subscribeToMore: {
                    document: PageRecipientOrderSubscription,
                    variables() {
                        return {
                            prGlobalId: this.$store.state.selectedRecipient.baseUuid,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        // needed to refetch in order to fetch updated pageInfo and cursors
                        const { order, orderCount } = subscriptionData.data.copilotOrderDetails;
                        this.addOrder(order, orderCount);
                        return previousResult;
                    },
                },
            },
        },
    })
], AffiliateAutomationTable);
export default AffiliateAutomationTable;
